import { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "../src/assets/components/global.css";
import Swal from "sweetalert2";
import Webcam from "react-webcam";

function Register() {
  const navigate = useNavigate();
  const [firstname, setFirstname] = useState("");
  const [middlename, setMiddlename] = useState("");
  const [lastname, setLastname] = useState("");
  const [age, setAge] = useState("");
  const [birthdate, setBirthdate] = useState(""); //birthdate
  const [gender, setGender] = useState(""); //birthdate
  const [cellnumber, setCellnumber] = useState("");
  const [civilstatus, setCivilstatus] = useState("Single");
  const [religion, setReligion] = useState("Other");
  const [nationality, setNationality] = useState("Not Set");
  const [occupation, setOccupation] = useState("None");
  const [recentaddress, setRecentaddress] = useState("");
  const [presentaddress, setPresentaddress] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("member"); // Default role is "member"
  const [brgyId, setbrgyId] = useState(""); // State for auto-incremented numbers
  const [bId, setbId] = useState(""); // State for auto-incremented numbers
  const [photo, setPhoto] = useState(""); // State for storing the captured photo
  const [hasCamera, setHasCamera] = useState(false);
  const [cameraDeviceId, setCameraDeviceId] = useState(null);
  const [photoTaken, setPhotoTaken] = useState(false);
  const [isCameraVisible, setIsCameraVisible] = useState(true);

  const webcamRef = useRef(null);

  const capturePhoto = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    setPhoto(imageSrc);
    setPhotoTaken(true);
  }, [webcamRef]);

  const retakePhoto = useCallback(() => {
    setPhoto("");
    setPhotoTaken(false);
  }, []);

  useEffect(() => {
    const fetchBrgyId = async () => {
      try {
        const response = await fetch(
          "https://brgytracerappserver.onrender.com/register"
        );
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        if (data.brgyId) {
          setbrgyId(data.brgyId);
          setbId(data.bId);
        }
      } catch (error) {
        console.error("Error fetching or updating brgyId:", error);
      }
    };

    const checkCamera = async () => {
      try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const videoDevices = devices.filter(
          (device) => device.kind === "videoinput"
        );
        if (videoDevices.length > 0) {
          setHasCamera(true);
          setCameraDeviceId(videoDevices[0].deviceId); // Use the first available camera
        } else {
          setHasCamera(false);
        }
      } catch (error) {
        console.error("Error checking camera availability:", error);
      }
    };

    fetchBrgyId();
    checkCamera();
  }, []);

  const handleSave = (event) => {
    event.preventDefault();

    // Check if photo is taken
    if (!photoTaken) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please take a photo!",
      });
      return;
    }
    const userData = {
      bId,
      brgyId,
      firstname,
      middlename,
      lastname,
      age,
      birthdate,
      gender,
      cellnumber,
      civilstatus,
      religion,
      nationality,
      occupation,
      recentaddress,
      presentaddress,
      username,
      email,
      password,
      role,
      photo, // Include the captured photo in the user data
    };
    console.log("Sending data to server:", userData);

    // Make a POST request to the server to handle registration
    fetch("https://brgytracerappserver.onrender.com/register", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(userData),
    })
      .then((response) => response.json())
      .then((data) => {
        // Handle the response from the server
        console.log(data);
        if (data.status === "adminExist") {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "You dont have permission to admin!",
          });
        } else if (data.status === "usernameExists") {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Username Unavailable!",
          });
        } else if (data.status === "emailExists") {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Email Unavailable!",
          });
        } else if (data.status === "success") {
          Swal.fire({
            // position: "top-end",
            icon: "success",
            title: "Successfully Saved!",
            showConfirmButton: true,
            // timer: 1500,
          }).then(() => {
            // Refresh the page
            window.location.reload();
          });
        }
        // Redirect or show a success message based on the response
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Something went wrong!",
          text: "System error!!",
        });
      });
  };

  const handleclose = () => {
    navigate("/login");
  };
  const hidecamera = () => {
    setIsCameraVisible(true);
  };
  const showcamera = () => {
    setIsCameraVisible(!isCameraVisible);
  };

  return (
    <div className="register-parent wrap parent-height register">
      <div className="form-holder">
        <form onSubmit={handleSave} className="register-container">
          <button
            type="btn"
            className="closebtn"
            onClick={handleclose} //close the page and back to login page
          >
            X
          </button>
          <h1>Registration form</h1>
          <div className="autonumbers">
            <label>BrgyID: {brgyId}</label>
          </div>
          <div className="content-container showcamera">
            {/* picture image here that can use camera */}
            <div
              className={`camera-holder ${isCameraVisible ? "hide-it" : ""}`}>
              <div className="webcam-container">
                {photoTaken ? (
                  <div className="photo-preview">
                    <img src={photo} alt="Captured" />
                  </div>
                ) : (
                  <div
                    className={
                      hasCamera
                        ? "webcam-holder"
                        : "webcam-holder no-camera-detected"
                    }>
                    <Webcam
                      audio={false}
                      ref={webcamRef}
                      screenshotFormat="image/jpeg"
                      width={300}
                      height={300}
                      videoConstraints={{ deviceId: cameraDeviceId }}
                    />
                  </div>
                )}
                <div>
                  {photoTaken ? (
                    <div className="buttons-container">
                      <button
                        type="button"
                        onClick={retakePhoto}
                        disabled={!hasCamera}
                        className="button-retake">
                        Retake
                      </button>
                      <button
                        className="hidden-camera"
                        type="button"
                        onClick={hidecamera}>
                        Hide
                      </button>
                    </div>
                  ) : (
                    <div className="buttons-container">
                      <button
                        type="button"
                        onClick={capturePhoto}
                        disabled={!hasCamera}
                        className="button-capture">
                        Capture
                      </button>
                      <button
                        className="hidden-camera"
                        type="button"
                        onClick={hidecamera}>
                        Hide
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <label>Account Information</label>
            <div className="accountbox-container">
              <div>
                <label htmlFor="username">Username:</label>
                <input
                  type="text"
                  // placeholder="Enter Username"
                  required
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="email">Email:</label>
                <input
                  type="email"
                  // placeholder="Enter Email"
                  required
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="password">Password:</label>
                <input
                  type="password"
                  // placeholder="Enter Password"
                  required
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="role">Role:</label>
                <select value={role} onChange={(e) => setRole(e.target.value)}>
                  <option value="member">Member</option>
                  <option value="officer">Officer</option>
                  <option value="admin">Admin</option>
                </select>
              </div>
            </div>
            <label>User Information</label>
            <div className="userinfo-container">
              <div>
                <label htmlFor="firstname">First name:</label>
                <input
                  type="text"
                  // placeholder="Enter Firstname"
                  required
                  onChange={(e) => setFirstname(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="middlename">Middle Name:</label>
                <input
                  type="text"
                  // placeholder="Enter Middle Name"
                  required
                  onChange={(e) => setMiddlename(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="lastname">Family Name:</label>
                <input
                  type="text"
                  // placeholder="Enter Family Name"
                  required
                  onChange={(e) => setLastname(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="age">Age:</label>
                <input
                  type="text"
                  // placeholder="Enter Age"
                  required
                  min="0" // Specify minimum age
                  maxLength={3} // Set the maximum length to 3
                  pattern="[0-9]*" // Allow only numeric values
                  onKeyPress={(e) => {
                    // Allow only numeric characters and the Enter key
                    if (isNaN(e.key) && e.key !== "Enter") {
                      e.preventDefault();
                    }
                  }}
                  onChange={(e) => {
                    // Remove non-numeric characters
                    const numericValue = e.target.value.replace(/[^0-9]/g, "");

                    // Update the state with the numeric value
                    setAge(numericValue);
                  }}
                />
              </div>
              <div>
                <label htmlFor="Birth-Date">Birth Date:</label>
                <input
                  type="date"
                  // placeholder="Enter Birth-Date"
                  required
                  onChange={(e) => setBirthdate(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="Gender">Gender:</label>
                <select
                  value={gender}
                  onChange={(e) => setGender(e.target.value)}>
                  <option value="Other">Other</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Lesbian">Lesbian</option>
                </select>
              </div>
              <div>
                <label htmlFor="phoneNumber">Contact Number:</label>
                <input
                  type="text"
                  // placeholder="Enter Phone Number"
                  required
                  pattern="[0-9]{4} [0-9]{3} [0-9]{4}"
                  value={cellnumber}
                  onChange={(e) => {
                    const formattedValue = e.target.value.replace(
                      /[^0-9 ]/g,
                      ""
                    );

                    // Update the state with the formatted value
                    setCellnumber(formattedValue);
                  }}
                />
                <small>Format: 0000 000 0000</small>
              </div>
              <div>
                <label htmlFor="civilstatus">Civil Status:</label>
                <select
                  value={civilstatus}
                  onChange={(e) => setCivilstatus(e.target.value)}>
                  <option value="Single">Single</option>
                  <option value="Married">Married</option>
                  <option value="Widowed">Widowed</option>
                  <option value="Separated">Separated</option>
                  <option value="Divorced ">Divorced</option>
                  <option value="Annulled ">Annulled</option>
                </select>
              </div>
              <div>
                <label htmlFor="religion">Religion:</label>
                <select
                  value={religion}
                  onChange={(e) => setReligion(e.target.value)}>
                  <option value="Other">Other</option>
                  <option value="Roman Catholic">Roman Catholic</option>
                  <option value="Iglesia ni Cristo">INC</option>
                  <option value="Evangelicals">Evangelicals</option>
                  <option value="Baptists">Baptists</option>
                  <option value="Methodists">Methodists</option>
                  <option value="Seventh-day Adventists">SDA</option>
                  <option value="Pentecostals">Pentecostals</option>
                  <option value="Jehovah's Witnesses">
                    Jehovah's Witnesses
                  </option>
                  <option value="Assemble of God">Assemble of God</option>
                </select>
              </div>
              <div>
                <label htmlFor="Nationality">Nationality:</label>
                <select
                  value={nationality}
                  onChange={(e) => setNationality(e.target.value)}>
                  <option value="Filipino">Filipino</option>
                  <option value="American">American</option>
                  <option value="Chinese">Chinese</option>
                  <option value="Japanese">Japanese</option>
                  <option value="Korean">Korean</option>
                  <option value="Indian">Indian</option>
                  <option value="Australian">Australian</option>
                  <option value="British">British</option>
                  <option value="Ohter">Ohter</option>
                </select>
              </div>
              <div>
                <label htmlFor="occupation">Occupation:</label>
                <select
                  value={occupation}
                  onChange={(e) => setOccupation(e.target.value)}>
                  <option value="None">None</option>
                  <option value="Labor">Labor</option>
                  <option value="HouseWife">HouseWife</option>
                  <option value="Teacher">Teacher</option>
                  <option value="Principal">Principal</option>
                  <option value="Professor">Professor</option>
                  <option value="Librarian">Librarian</option>
                  <option value="Special Education Teacher">
                    Special Education Teacher
                  </option>
                  <option value="Academic Advisor">Academic Advisor</option>
                  <option value="Software Engineer">Software Engineer</option>
                  <option value="Mechanical Engineer">
                    Mechanical Engineer
                  </option>
                  <option value="Civil Engineer">Civil Engineer</option>
                  <option value="Electrical Engineer">
                    Electrical Engineer
                  </option>
                  <option value="Chemical Engineer">Chemical Engineer</option>
                  <option value="Biomedical Engineer">
                    Biomedical Engineer
                  </option>
                  <option value="Data Scientist">Data Scientist</option>
                  <option value="Network Administrator">
                    Network Administrator
                  </option>
                  <option value="IT Support Specialist">
                    IT Support Specialist
                  </option>
                  <option value="Systems Analyst">Systems Analyst</option>
                  <option value="Doctor">Doctor</option>
                  <option value="Nurse">Nurse</option>
                  <option value="Pharmacist">Pharmacist</option>
                  <option value="Physical Therapist">Physical Therapist</option>
                  <option value="Medical Technologist">
                    Medical Technologist
                  </option>
                  <option value="Radiologic Technologist">
                    Radiologic Technologist
                  </option>
                  <option value="Occupational Therapist">
                    Occupational Therapist
                  </option>
                  <option value="Accountant">Accountant</option>
                  <option value="Financial Advisor">Financial Advisor</option>
                  <option value="Marketing Manager">Marketing Manager</option>
                  <option value="Sales Manager">Sales Manager</option>
                  <option value="Human Resources Manager">
                    Human Resources Manager
                  </option>
                  <option value="Operations Manager">Operations Manager</option>
                  <option value="Entrepreneur">Entrepreneur</option>
                  <option value="Consultant">Consultant</option>
                  <option value="Project Manager">Project Manager</option>
                  <option value="Farmer">Farmer</option>
                  <option value="Agricultural Scientist">
                    Agricultural Scientist
                  </option>
                  <option value="Agronomist">Agronomist</option>
                  <option value="Veterinarian">Veterinarian</option>
                  <option value="Poultry Farmer">Poultry Farmer</option>
                  <option value="Lawyer">Lawyer</option>
                  <option value="Judge">Judge</option>
                  <option value="Police Officer">Police Officer</option>
                  <option value="Firefighter">Firefighter</option>
                  <option value="Security Guard">Security Guard</option>
                  <option value="Detective">Detective</option>
                  <option value="Forensic Scientist">Forensic Scientist</option>
                  <option value="Graphic Designer">Graphic Designer</option>
                  <option value="Journalist">Journalist</option>
                  <option value="Photographer">Photographer</option>
                  <option value="Electrician">Electrician</option>
                  <option value="Plumber">Plumber</option>
                  <option value="Welder">Welder</option>
                  <option value="Mason">Mason</option>
                  <option value="Construction Manager">
                    Construction Manager
                  </option>
                  <option value="Painter">Painter</option>
                  <option value="Heavy Equipment Operator">
                    Heavy Equipment Operator
                  </option>
                  <option value="HVAC Technician">HVAC Technician</option>
                  <option value="Housekeeper">Housekeeper</option>
                  <option value="Bartender">Bartender</option>
                  <option value="Store Manager">Store Manager</option>
                </select>
              </div>
              <div>
                <label htmlFor="recentaddress">Recentaddress:</label>
                <input
                  type="text"
                  // placeholder="Enter Family Name"
                  required
                  onChange={(e) => setRecentaddress(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="presentaddress">Presentaddress:</label>
                <input
                  type="text"
                  // placeholder="Enter Street"
                  required
                  onChange={(e) => setPresentaddress(e.target.value)}
                />
              </div>
            </div>
            <div className="isshowcamera" onClick={showcamera}></div>
            <button className="registerbtn" type="submit">
              Register
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Register;
